exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mobilehead{position:relative;padding:5px 0 20px 5px}.mobilehead-logo{width:236px}.mobilehead-logo img{width:100%}.mobilehead-loginbtn{top:0}.mobilehead-loginbtn,.mobilehead-menu{position:absolute;right:0;color:#fff;font-size:25px;text-align:center;background:#ec5e0c;padding:12px 15px;min-width:60px}.mobilehead-menu{bottom:0}.mobilehead_content a{background:#ec5e0c;width:90%;display:block;padding:10px 0;text-align:center;color:#fff;margin:20px auto;cursor:pointer}.mobilehead_content a:active,.mobilehead_content a:focus,.mobilehead_content a:hover{color:#fff;text-decoration:none}", ""]);

// exports
